import * as PIXI from "pixi.js";
import UILayer from "../layers/UILayer";
import TextureManager from "../managers/TextureManager";
import { EventBus, EnumEventBus } from "../managers/EventBus";
import { ButtonBounds } from "../types/Interface";


const STOP_ASSETS_PATH = "./images/scene/stop.png";


export default class AutoPlayStopBar extends PIXI.Container {
  private UILayer = UILayer.getInstance();
  private EventBus = EventBus;
  private bounds: ButtonBounds;
  private count: PIXI.Text;
  constructor(bounds: ButtonBounds) {
    super();
    this.bounds = bounds;
    Object.assign(this, bounds);
    this.addStopButton();
    this.addGameCountDown();
    this.setVisible(false);
    this.addToLayer();
    this.EventBus.on(EnumEventBus.setStopBarCount, v => this.setStopBarStatus(Number(v)))
  }
  setVisible = (v: boolean) => this.visible = v;
  setStopBarStatus(v: number) {
    if (v > 0) {
      !this.visible && this.setVisible(true);
      this.setCount(v);
    }else{
      this.setVisible(false);
    }
  }
  addStopButton() {
    const stopTexture = TextureManager.getTexture(STOP_ASSETS_PATH);
    const stop = new PIXI.Sprite(stopTexture);
    stop.anchor.set(.5);
    stop.width = this.bounds.width;
    stop.height = this.bounds.height;
    stop.x = 0;
    stop.y = 0;
    this.addChild(stop);
  }
  addGameCountDown() {
    this.count = new PIXI.Text({ text: "0" });
    this.count.style.fill = 0xFFFFFF;
    this.count.anchor.set(.5);
    this.count.x = 35;
    this.count.y = 0;
    this.addChild(this.count);
  }
  setCount(value: number) {
    this.count.text = value.toString();
  }
  addToLayer() {
    this.UILayer.addChild(this);
  }
}